import React, { useEffect, useState } from "react";
import { InputCheckBoxTableStyled } from "./styled";
import cx from "classnames";

export const InputCheckBoxTable = ({
  theme_standard_input_check_box,
  theme_standard_input_check_box_round,
  theme_standard_input_check_box_square,
  theme_standard_input_check_box_square_account,
  input_check_box_square_light_blue,
  theme_blue_square,
  theme_dark_blue,
  theme_purple,
  label,
  value,
  checked,
  fontSize,
  fontFamily,
  fontColor,
  onChange,
  onChangeCustom,
  disabled,
}) => {
  const customClass = cx({
    theme_standard_input_check_box: theme_standard_input_check_box,
    input_check_box_square_light_blue: input_check_box_square_light_blue,
    theme_standard_input_check_box_round: theme_standard_input_check_box_round,
    theme_standard_input_check_box_square:
      theme_standard_input_check_box_square,
    theme_standard_input_check_box_square_account:
      theme_standard_input_check_box_square_account,
    theme_blue_square: theme_blue_square,
    theme_dark_blue: theme_dark_blue,
    theme_purple: theme_purple,
  });

  const [_value, _setValue] = useState();

  useEffect(() => {
    if (value) {
      _setValue(value);
    }
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  const onChangeEvent = (e) => {
    _setValue(e.target.checked);
    onChange && onChange(e);
    onChangeCustom && onChangeCustom(e.target.checked);
  };

  return (
    <InputCheckBoxTableStyled
      fontSize={fontSize}
      fontFamily={fontFamily}
      fontColor={fontColor}
      disabled={disabled}
    >
      <div className={customClass}>
        <label className="container">
          <input
            type="checkbox"
            name={value}
            value={_value}
            checked={checked}
            onChange={onChangeEvent}
            disabled={disabled}
          />
          <span className="checkmark"></span>
          {label && (
            <span
              className={`lable_show ${
                _value ? "active_font" : disabled ? "dis_font" : ""
              }`}
            >
              {label}
            </span>
          )}
        </label>
      </div>
    </InputCheckBoxTableStyled>
  );
};

export default InputCheckBoxTable;
